import * as React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import {useDataProvider} from '../../fetchApi/dataProvider';
import {FETCH} from '../../fetchApi/types';
import {endpointSendVerificationLetter, resourceCustomUsers} from '../../constants';
import {NotificationManager} from 'react-notifications';
import {compose} from 'redux';
import {connect} from 'react-redux';
import * as _ from 'lodash';
import {setRegistrationEmail} from '../../actions';
import {RouteChildrenProps, withRouter} from 'react-router-dom';

interface EmailVerificationDialogProps extends RouteChildrenProps {
    onClose: (email: string) => void;
    email: string;
}

const DialogView: React.FunctionComponent<EmailVerificationDialogProps> = ({
    onClose,
    email,
    history
}) => {
    const {t: translate} = useTranslation();
    const {dataProvider} = useDataProvider();
    const [timer, setTimer] = React.useState(0);

    const startTimer = React.useCallback(() => {
        let localSeconds = 60;
        setTimer(localSeconds);
        const interval = setInterval(() => {
            if (localSeconds > 0) {
                localSeconds--;
                setTimer(localSeconds);
            } else {
                clearInterval(interval);
            }
        }, 1000);
    }, []);

    const sendVerificationEmail = React.useCallback(() => {
        dataProvider(FETCH, `${resourceCustomUsers}/${endpointSendVerificationLetter}`, {email})
            .then(() => {
                NotificationManager.success(translate('users.email.notifications.send_success'));
                startTimer();
            })
            .catch(e => {
                NotificationManager.error(e.message);
            });
    }, [email]);

    React.useEffect(() => {
        if (email) {
            startTimer();
        }
    }, [email]);

    return (
        <Dialog
            open={!!email}
            disableBackdropClick
            disableEscapeKeyDown
        >
            <DialogTitle>
                {translate('users.email.dialog_title')}
            </DialogTitle>
            <DialogContent>
                {translate('users.email.dialog_content', {email})}
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={(): void => sendVerificationEmail()}
                    color='primary'
                    variant='contained'
                    disabled={timer > 0}
                >
                    {timer > 0 ?
                        translate('users.email.actions.send_again_timer', {timer}) :
                        translate('users.email.actions.send_again')
                    }
                </Button>
                <Button
                    onClick={(): void => {
                        onClose('');
                        history.push('/');
                    }}
                >
                    {translate('common.actions.close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state: Record<string, any>): { email: string } => {
    const userRegistrationEmail: string = _.get(state, 'authUser.registrationEmail', '');
    return {email: userRegistrationEmail};
};

// @ts-ignore
const EmailVerificationDialog: React.ComponentType<Record<string, unknown>> = compose(
    connect(mapStateToProps, {onClose: setRegistrationEmail}),
    withRouter
)(DialogView);

export default EmailVerificationDialog;